
import gql from "graphql-tag";
const getODD = gql(`
  query MyQuery {
    odd_ODD {
      GPName
      column_0A
      column_0B
      column_0C
      column_0D
      column_0E
      column_10A
      column_10B
      column_10C
      column_10D
      column_10E
      column_10F
      column_10G
      column_1A
      column_1B
      column_1C
      column_1D
      column_1E
      column_1F
      column_1G
      column_1H
      column_2A
      column_2B
      column_2C
      column_2D
      column_2E
      column_2F
      column_3A
      column_3B
      column_3C
      column_4A
      column_4B
      column_4C
      column_4D
      column_4E
      column_4F
      column_4G
      column_4H
      column_4I
      column_4J
      column_4K
      column_4L
      column_4M
      column_5A
      column_5B
      column_5C
      column_6Ai
      column_6Aii
      column_6Aiii
      column_6Aiv
      column_6Av
      column_6Avi
      column_6B
      column_7A
      column_7B
      column_7C
      column_7D
      column_7E
      column_7F
      column_7G
      column_7H
      column_7I
      column_7J
      column_8A
      column_8B
      column_8C
      column_8D
      column_8E
      column_8F
      column_8G
      column_9A
      column_9B
      column_9C
      column_9D
      column_9E
      column_9F
    }
  }
`);
export default getODD
